var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" }, [
      _c(
        "div",
        [
          _vm.isBetweenPromotionDays
            ? [
                _c("img", {
                  staticClass: "card-img-top",
                  attrs: {
                    src:
                      "https://beneat.s3.ap-southeast-1.amazonaws.com/q_chang/beneat_qchang.png",
                    alt: ""
                  }
                })
              ]
            : [
                _c("img", {
                  staticClass: "card-img-top",
                  attrs: {
                    src: "/static/img/qChang/q_chang_combination_Aircon2.png",
                    alt: ""
                  }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c("section", { staticClass: "px-3" }, [
        _c("div", { staticClass: "py-4 title" }, [
          _vm._v("\n        BeNeat ร่วมกับ Q-CHANG (คิวช่าง)\n      ")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "py-4" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-info btn-lg",
                attrs: { to: "/q-chang/2" }
              },
              [_vm._v('\n          เข้าสู่ระบบ "คิวช่าง"\n        ')]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _vm._v("\n        ศูนย์รวมช่างคุณภาพและบริการดูแลบ้านครบวงจร"),
      _c("br"),
      _vm._v("\n        เพื่อเพิ่มความสะดวกสบายให้กับคุณลูกค้า"),
      _c("br"),
      _vm._v(
        "\n        โดยคุณลูกค้าสามารถจองบริการช่างล้างแอร์ และล้างเครื่องซักผ้า"
      ),
      _c("br"),
      _vm._v("\n        จากคิวช่างได้โดยตรง ผ่าน Application BeNeat\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-3" }, [
      _vm._v("\n        บริการนี้อยู่ระหว่างการทดสอบให้บริการ"),
      _c("br"),
      _vm._v("\n        คุณลูกค้าสามารถกดปุ่มด้านล่างเพื่อเข้าสู่ระบบคิวช่าง"),
      _c("br"),
      _vm._v("\n        และทำการจองบริการต่าง ๆ ของคิวช่างได้โดยตรง\n      ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d353b52c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d353b52c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qChang/Step1.vue
// module id = 2257
// module chunks = 0